"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var icon_1 = require("../constants/img/icon");
var color_1 = require("../components/common/color");
var SwiperNavArrows = function (_a) {
    var bgColor = _a.bgColor, color = _a.color, prevDisabled = _a.prevDisabled, nextDisabled = _a.nextDisabled;
    var swiper = (0, react_1.useSwiper)();
    var buttonBackgroundColor = bgColor && { backgroundColor: (0, color_1.toHex)(bgColor) };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("button", { className: "swiper-button swiper-button--next ".concat(color ? "swiper-button--".concat(color) : '', " ").concat(nextDisabled ? 'swiper-button--disabled' : ''), onClick: function () { return swiper.slideNext(); }, style: buttonBackgroundColor },
            (0, preact_1.h)("img", { className: "swiper-button__right-arrow", src: icon_1.CAROUSEL_RIGHT_ARROW, alt: "next button" })),
        (0, preact_1.h)("button", { className: "swiper-button swiper-button--previous ".concat(color ? "swiper-button--".concat(color) : '', " ").concat(prevDisabled ? 'swiper-button--disabled' : ''), onClick: function () { return swiper.slidePrev(); }, style: buttonBackgroundColor },
            (0, preact_1.h)("img", { className: "swiper-button__left-arrow", src: icon_1.CAROUSEL_LEFT_ARROW, alt: "previous button" }))));
};
exports.default = SwiperNavArrows;
